import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GET_EXAM_LEVELS_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export enum ExamLevel {
  GCEA = 'GCE A-LEVEL',
  GCEN = 'GCE N-LEVEL',
  GCEO = 'GCE O-LEVEL',
  PSLE = 'PSLE',
}

export interface ExamLevelModel {
  code: string;
  // description type is modified so that ExamLevelModel can be used for Non-National Exam Level
  description: ExamLevel | string;
}

export interface ExamLevelRequest {
  codeType: string;
  codeInList: string[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostExamLevels = ({ onSuccess, onError }: Input = {}) => {
  const postExamLevels = async (reqBody: ExamLevelRequest) => {
    const res = await axiosClient.post<ExamLevelModel[]>(GET_EXAM_LEVELS_URL, reqBody);
    return res.data;
  };

  return useCustomMutation(postExamLevels, {
    onSuccess,
    onError,
  });
};
